import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/GruppPsy.css';

function GruppPsy() {
  return (
    <main className="group-page">

      {/* ========================================
          ШАПКА
          ======================================== */}
      <section className="group-intro">
        <div className="app-container">
          <div className="group-intro__simple">

            <h1>Психотерапевтические группы</h1>

            <p>
              <strong>Психотерапевтическая группа</strong> — это сообщество
              людей, объединённых с целью решения личных проблем
              и внутренних конфликтов.
            </p>

          </div>
        </div>
      </section>


      {/* ========================================
          ФОРМАТЫ
          ======================================== */}
      <section className="group-formats">
        <div className="app-container">

          <h2 className="group-section-title">
            Форматы участия
          </h2>

          <div className="group-formats__grid">

            {/* ОЧНО */}
            <article className="group-format-card">
              <div className="group-format-card__heading">
                <h3>Очно</h3>

                <span>
                  Присоединиться к работающей группе
                </span>
              </div>

              <ul>
                <li>Формат встреч: очно</li>
                <li>Частота: 1 раз в неделю, в фиксированное время</li>
                <li>Длительность: 1,5 часа</li>
                <li>Участников: 10–12 человек</li>
                <li>Стоимость одной встречи: 1500 ₽</li>
              </ul>

              <p>
                Чтобы присоединиться или задать вопросы — напишите
                ведущему группы Фёдорову Игорю Валерьевичу.
              </p>
            </article>


            {/* ОНЛАЙН */}
            <article className="group-format-card">
              <div className="group-format-card__heading">
                <h3>Онлайн</h3>

                <span>
                  С 1 ноября стартует новая группа — в дистанционном формате
                </span>
              </div>

              <ul>
                <li>Формат встреч: онлайн</li>
                <li>Частота: 1 раз в неделю, в фиксированное время</li>
                <li>Длительность: 1,5 часа</li>
                <li>Участников: 10–12 человек</li>
                <li>Стоимость одной встречи: 1500 ₽</li>
              </ul>

              <p>
                Если вы хотите участвовать — напишите ведущему группы
                Фёдорову Игорю Валерьевичу.
              </p>
            </article>

          </div>

          <div className="group-contact-line">
            <a
              href="https://t.me/Fedorov_App"
              target="_blank"
              rel="noopener noreferrer"
            >
              Telegram
            </a>

            <a href="tel:+79039553396">
              +7 (903) 955-33-96
            </a>
          </div>

        </div>
      </section>


      {/* ========================================
          КАК РАБОТАЕТ ГРУППА
          ======================================== */}
          <div className="group-longread">
      <section className="group-content">
        <div className="app-container">
          <div className="group-content__inner">

            <h2>
              Как работает психотерапевтическая группа
            </h2>

            <p>
              <strong>
                Группа помогает осознать бессознательные процессы,
                которые управляют вашей жизнью без вашего ведома.
              </strong>{' '}
              Именно в бессознательном «хранятся» вытесненные травмы
              и неразрешённые конфликты. Оставаясь скрытыми, они продолжают
              влиять на ваши решения, отношения и самочувствие —
              часто причиняя страдания.
            </p>

            <p className="group-content__small-title">
              Например:
            </p>

            <ul>
              <li>
                Вы снова и снова выбираете болезненные отношения,
                которые неизбежно заканчиваются разрывом;
              </li>

              <li>
                Чувствуете постоянную усталость или физические недомогания,
                несмотря на отсутствие медицинских диагнозов;
              </li>

              <li>
                Не можете определиться с жизненными целями — работа,
                увлечения, отношения всё время меняются.
              </li>
            </ul>

            <p>
              <strong>
                У всего этого есть глубинные причины — и их можно обнаружить
                в процессе психотерапии.
              </strong>{' '}
              Группа становится мощным инструментом для этого исследования.
            </p>

          </div>
        </div>
      </section>


      {/* ========================================
          ГРУППА КАК СОЦИАЛЬНЫЙ МИР
          ======================================== */}
      <section className="group-content">
        <div className="app-container">
          <div className="group-content__inner">

            <h2>
              Группа — это мини-модель социального мира
            </h2>

            <p>
              Здесь, как и в жизни, вы сталкиваетесь с разными людьми,
              их реакциями, ожиданиями и эмоциями. Каждый участник приносит
              свой уникальный опыт — и именно это разнообразие помогает:
            </p>

            <p>
              <strong>
                Актуализировать бессознательные переживания и конфликты
              </strong>{' '}
              — пережить их заново, увидеть под другим углом, открыть
              в себе то, что раньше оставалось скрытым.
            </p>

          </div>
        </div>
      </section>


      {/* ========================================
          ЧТО ДАЁТ ГРУППА
          ======================================== */}
      <section className="group-content">
        <div className="app-container">
          <div className="group-content__inner">

            <h2>
              Что даёт работа в группе
            </h2>

            <p>
              Таким образом, группа даёт вам возможность:
            </p>

            <div className="group-benefits">

              <div className="group-benefit">
                <strong>
                  «Увидеть себя глазами других»
                </strong>

                <span>
                  понять, как вы воспринимаетесь, какие реакции вызываете.
                </span>
              </div>

              <div className="group-benefit">
                <strong>
                  Осознать свои истинные желания и цели
                </strong>

                <span>
                  то, что действительно важно для вас, а не для других.
                </span>
              </div>

            </div>

          </div>
        </div>
      </section>


      {/* ========================================
          КАК ПРОХОДИТ РАБОТА
          ======================================== */}
      <section className="group-content">
        <div className="app-container">
          <div className="group-content__inner">

            <h2>
              Как проходит работа
            </h2>

            <p>
              Работа проходит в форме свободного диалога — без заранее
              заданных тем.{' '}
              <strong>
                Задача ведущего — создать психологически безопасное пространство
              </strong>
              , где каждый может говорить открыто, не боясь осуждения
              или отвержения. Такая свобода — редкость в повседневной жизни,
              но именно она открывает путь к настоящим изменениям.
            </p>

            <p>
              <strong>
                Опыт, полученный в группе, можно и нужно переносить
                в реальную жизнь
              </strong>{' '}
              — он становится ресурсом для личностного роста
              и построения гармоничных отношений.
            </p>

          </div>
        </div>
      </section>
</div>

      <section className="group-home">
  <div className="app-container">
    <div className="group-home__inner">
      <Link
        to="/"
        className="group-button group-button--home"
      >
        На главную
      </Link>
    </div>
  </div>
</section>
      

    </main>
  );
}

export default GruppPsy;